import { render, staticRenderFns } from "./ServerUpdateStatusPopup.vue?vue&type=template&id=37973660&scoped=true&"
import script from "./ServerUpdateStatusPopup.vue?vue&type=script&lang=js&"
export * from "./ServerUpdateStatusPopup.vue?vue&type=script&lang=js&"
import style0 from "./ServerUpdateStatusPopup.vue?vue&type=style&index=0&id=37973660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37973660",
  null
  
)

export default component.exports